import { render, staticRenderFns } from "./NotificationJobList.vue?vue&type=template&id=0d585c5c&scoped=true"
import script from "./NotificationJobList.vue?vue&type=script&lang=ts"
export * from "./NotificationJobList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationJobList.vue?vue&type=style&index=0&id=0d585c5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d585c5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d585c5c')) {
      api.createRecord('0d585c5c', component.options)
    } else {
      api.reload('0d585c5c', component.options)
    }
    module.hot.accept("./NotificationJobList.vue?vue&type=template&id=0d585c5c&scoped=true", function () {
      api.rerender('0d585c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NotificationJobList.vue"
export default component.exports